export const RETRY_MAX_ATTEMPTS = 3;

const BASE_DELAY_MS = 1_000;
const MAX_DELAY_MS = 30_000;

/**
 * Exponential backoff with full jitter, capped at MAX_DELAY_MS. Jitter spreads retries from
 * many concurrent queries so an expired session cannot produce a synchronized request burst.
 */
export const backoffWithJitter = (attemptIndex: number): number => {
  const capped = Math.min(BASE_DELAY_MS * 2 ** attemptIndex, MAX_DELAY_MS);
  return capped / 2 + Math.random() * (capped / 2);
};
